import { lazyStartChat } from '../index';
import { getStore } from '../store/chatStore';
import ChatProvider from '../store/schema/ChatProvider';
import StartChatSource from '../store/schema/StartChatSource';

export interface StartChatProperty {
    smtpAddress: string;
    imAddress: string;
    imAddressUrl: string;
}

type CompleteCallbackType = (success: boolean, error?: string) => void;
type StartChatCallbackFunctionType = (
    properties: StartChatProperty,
    onChatStarted: CompleteCallbackType
) => void;

export default function getStartChatCallback(): StartChatCallbackFunctionType {
    const chatProvider = getStore().chatProvider;

    return chatProvider == ChatProvider.UCMA || chatProvider == ChatProvider.UCWA
        ? startChat
        : null;
}

function startChat(properties: StartChatProperty, onChatStarted: CompleteCallbackType) {
    const { imAddressUrl } = properties;
    lazyStartChat.import().then(startChat => {
        const success = startChat([imAddressUrl], undefined, StartChatSource.PersonaCard);
        onChatStarted(success, undefined);
    });
}
